import { ShoppingCartOutlined } from '@ant-design/icons';
import { Badge } from 'antd';
import { useEffect, useState } from 'react';
import { isEmpty } from 'underscore';
import useCartStore from '../../../../store/cartStore';
import styles from '../style/ShoppingCartButton.module.scss';

export default function ShoppingCartButton() {
  const shoppingItems = useCartStore((state) => state.shoppingItems);
  const [shoppingItemsCount, setShoppingItemsCount] = useState(0);

  useEffect(() => {
    let noItems = 0;
    if (!isEmpty(shoppingItems)) {
      Object.keys(shoppingItems).forEach((pointName: string) => {
        noItems += Object.keys(shoppingItems[pointName]).length;
      });
    }
    setShoppingItemsCount(noItems);
  }, [shoppingItems]);

  return (
    <Badge count={shoppingItemsCount} className={styles.cartBadge}>
      <ShoppingCartOutlined className={styles.cartIcon} />
    </Badge>
  );
}
